import { EntitlementsCacheLifetime, Environment } from './dto/enums';
export class QonversionConfig {
    constructor(projectKey, launchMode, environment = Environment.PRODUCTION, entitlementsCacheLifetime = EntitlementsCacheLifetime.MONTH, entitlementsUpdateListener = undefined, proxyUrl, kidsMode = false) {
        this.projectKey = projectKey;
        this.launchMode = launchMode;
        this.environment = environment;
        this.entitlementsCacheLifetime = entitlementsCacheLifetime;
        this.entitlementsUpdateListener = entitlementsUpdateListener;
        this.proxyUrl = proxyUrl;
        this.kidsMode = kidsMode;
    }
}
//# sourceMappingURL=QonversionConfig.js.map